// 枚举定义
export var SOURCE;
(function (SOURCE) {
    SOURCE[SOURCE["MEITUAN_APP"] = 1] = "MEITUAN_APP";
    SOURCE[SOURCE["DIANPING_APP"] = 2] = "DIANPING_APP";
    SOURCE[SOURCE["MEITUAN_MINIAPP"] = 3] = "MEITUAN_MINIAPP";
    SOURCE[SOURCE["HOTEL_MINIAPP"] = 4] = "HOTEL_MINIAPP";
    SOURCE[SOURCE["DIANPING_MINIAPP"] = 5] = "DIANPING_MINIAPP";
})(SOURCE || (SOURCE = {}));
export var PLATFORM;
(function (PLATFORM) {
    PLATFORM[PLATFORM["MEITUAN"] = 1] = "MEITUAN";
    PLATFORM[PLATFORM["DIANPING"] = 2] = "DIANPING";
})(PLATFORM || (PLATFORM = {}));
// 客户端类型枚举
export var BASE_CLIENT_TYPE;
(function (BASE_CLIENT_TYPE) {
    BASE_CLIENT_TYPE[BASE_CLIENT_TYPE["IPHONE"] = 1] = "IPHONE";
    BASE_CLIENT_TYPE[BASE_CLIENT_TYPE["ANDROID"] = 2] = "ANDROID";
    BASE_CLIENT_TYPE[BASE_CLIENT_TYPE["WX"] = 3] = "WX";
})(BASE_CLIENT_TYPE || (BASE_CLIENT_TYPE = {}));
